import useAuthHook from '@/hooks/auth'
import { useSearchParams } from 'next/navigation'
import { createContext, FunctionComponent, useContext, useEffect, useState } from 'react'

export interface authContextType {
  isdn?: string
  token?: string
  isWebView: boolean
  isMonPay: boolean
  isTouchScreen: boolean
  isLoggedIn?: boolean
}

const authContextDefaultValues: authContextType = {
  token: undefined,
  isdn: undefined,
  isWebView: false,
  isMonPay: false,
  isTouchScreen: false,
  isLoggedIn: false
}

const AuthContext = createContext<authContextType>(authContextDefaultValues)

export const useAuth = (): authContextType => {
  return useContext(AuthContext)
}

export const AuthProvider: FunctionComponent<{ children: React.ReactNode }> = ({ children }) => {
  const { token, isdn, isLoggedIn, handleWebview } = useAuthHook()
  const [isWebView, setWebView] = useState<boolean>(false)
  const [isTouchScreen, setTouchScreen] = useState<boolean>(false)
  const [isMonPay, setIsMonPay] = useState<boolean>(false)


  const paramToken = useSearchParams().get('t')
  const source = useSearchParams().get('source')
  const isKaos = useSearchParams().get('theme')

  useEffect(() => {
    if (isKaos?.includes('kaos')) {
      setIsMonPay(true)
    }
  }, [isKaos])

  useEffect(() => {
    if (paramToken !== null && paramToken.trim() !== '' && typeof window !== 'undefined') {
      handleWebview(window.atob(paramToken))
    }
  }, [handleWebview, paramToken])
  useEffect(() => {
    if (source === 'touchscreen') {
      setTouchScreen(true)
    }
  }, [source])

  useEffect(() => {
    const globalWindow = window as any
    const userAgent = window.navigator.userAgent
    const hasWebViewBridge =
      globalWindow.ReactNativeWebView !== undefined ||
      globalWindow.ReactNativeWebview !== undefined ||
      globalWindow.mobiBridge !== undefined ||
      globalWindow.flutter_inappwebview !== undefined
    const isMobileWebViewUserAgent =
      /\bwv\b/i.test(userAgent) ||
      (/(iPhone|iPad|iPod)/i.test(userAgent) && !/Safari/i.test(userAgent))

    if (hasWebViewBridge || isMobileWebViewUserAgent) {
      setWebView(true)
    }
  }, [])

  return (
    <AuthContext.Provider value={{
      token,
      isdn,
      isWebView,
      isMonPay,
      isTouchScreen,
      isLoggedIn
    }}
    >
      {children}
    </AuthContext.Provider>
  )
}
